import Vue from 'vue';
import App from './App.vue';
import store from './store/index';
import ApiService from './services/api.service';
import router from './routes';
import isAuthenticated from './modules/auth.module';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import './plugins/bootstrap-vue';
import './plugins/highcharts';
import './plugins/vue-select';
import vuetify from './plugins/vuetify'

let debug = false;

let apiBaseUrl = '';

if (isAuthenticated) {
  let urlParams = new URLSearchParams(window.location.search);
  let jwtToken = urlParams.get('token');

  let tokenParts = jwtToken.split('.');
  let decodedData = JSON.parse(window.atob(tokenParts[1]));
  debug = decodedData.debug;  // O debug é coletado do backend

  // Set the base URL of the API
  if (debug) {
    // Forçar localhost em desenvolvimento
    apiBaseUrl = "http://localhost:8000/api/admin/";
  } else {
    apiBaseUrl = "https://" + decodedData.domain + "/api/admin/";
  }
  ApiService.init(apiBaseUrl);
  
  // Para desenvolvimento local, não precisamos de token JWT
  // O sistema usará cookies/sessão automaticamente
  if (!debug) {
    // Em produção, usar token JWT
    ApiService.setHeader('Bearer ' + jwtToken);
  }
} else {
  router.push('/Unauthorized');
}

if (!debug) {
  Sentry.init({
    dsn: 'https://b56c504a69d74d0fa1cdb572203d4b03@sentry.io/1534841',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    release: 'shoppub-dashboard@1.0.1',
    environment: debug ? 'development' : 'production'
  });
}

Vue.config.productionTip = false;

new Vue({
  store,
  router: router,
  vuetify,
  render: h => h(App)
}).$mount('#app');
